module.exports = __webpack_public_path__ + "static/media/crypto-transaction-white.6871142d.png";